import React from 'react'
import Link from 'components/Link'

type ImportantLinkProps = {
    to: string
    icon?: string
    title: string
    badge?: 'new' | 'beta' | undefined
    children?: React.ReactNode
}

export const ImportantLink: React.FC<ImportantLinkProps> = ({ to, icon, title, badge, children }) => {
    const badgeClass = badge === 'new' ? 'success' : badge === 'beta' ? 'warning' : null

    return (
        <Link
            className="flex items-center space-x-2 rounded p-2 text-[14px] font-semibold text-almost-black hover:bg-gray-accent/40 hover:text-almost-black active:hover:bg-gray-accent/60 dark:text-white dark:hover:bg-gray-accent/10 dark:hover:text-white dark:active:bg-gray-accent/5"
            to={to}
        >
            {icon ? <img src={icon} className="h-5 w-5" /> : children || null}
            <span>{title}</span>
            {badge && <span className={`lemon-tag ${badgeClass}`}>{badge}</span>}
        </Link>
    )
}
export default ImportantLink
